import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import "./Pooja.css";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { ImageGallerySlider } from "../../component/comman/image-gallery-slider/ImageGallerySlider";
import { Faq } from "../../component/comman/Faq/Faq";
import AOS from "aos";
import "aos/dist/aos.css";

export const Pooja = () => {
  const poojaData = useSelector((state) => state.gallery?.poojaSchedule);
  const [showAll, setShowAll] = useState(false);

  const eventsToDisplay = showAll
    ? poojaData?.events || []
    : (poojaData?.events || []).slice(0, 4);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div>
      <p className="intro" data-aos="fade-up">
        Welcome to Adhie Annan Temple, a sacred place of devotion and peace.
        Join us for daily poojas, aartis, and special rituals, where prayers
        fill the air with positivity and divine grace. Seek blessings from our
        revered deities and experience spiritual harmony. Whether you visit for
        morning darshan, evening aarti, or special festival celebrations, the
        temple welcomes you with open arms.
        <br />
        பக்தி மற்றும் அமைதிக்கான புனித இடமான அதி அன்னான் கோயிலுக்கு வருக. தினசரி
        பூஜைகள், ஆரத்திகள் மற்றும் சிறப்பு சடங்குகளுக்கு எங்களுடன் சேருங்கள்,
        அங்கு பிரார்த்தனைகள் காற்றை நேர்மறை மற்றும் தெய்வீக அருளால்
        நிரப்புகின்றன. எங்கள் மதிப்பிற்குரிய தெய்வங்களின் ஆசீர்வாதங்களைப் பெற்று
        ஆன்மீக நல்லிணக்கத்தை அனுபவிக்கவும். நீங்கள் காலை தரிசனம், மாலை ஆரத்தி
        அல்லது சிறப்பு விழா கொண்டாட்டங்களுக்குச் சென்றாலும், கோயில் உங்களை
        இருகரம் நீட்டி வரவேற்கிறது.
      </p>

      <div className="pooja-container">
        <div className="timeline">
          {eventsToDisplay.map((event, idx) => (
            <div
              className={`event ${idx % 2 === 0 ? "right" : "left"}`}
              key={idx}
              data-aos={idx % 2 === 0 ? "fade-down" : "fade-up"}
            >
              <div className="event-dot" />
              <div className="content-box">
                <h2>{event.title}</h2>
                <p className="time">{event.time}</p>
                <img src={event.image} alt={event.title} />
                <p className="desc">{event.description}</p>
              </div>
            </div>
          ))}

       <div className="read-wrapper" >
            <button
              className="read-button"
              onClick={() => setShowAll((prev) => !prev)}
            >
              {showAll ? (
                <>
                  See Less <FaChevronUp />
                </>
              ) : (
                <>
                  See More <FaChevronDown />
                </>
              )}
            </button>
          </div>

          {!showAll && <div className="fade-gradient-pooja" />}
        </div>
      </div>

      <div data-aos="fade-up">
        <ImageGallerySlider />
      </div>

      <div data-aos="fade-up">
        <Faq />
      </div>
    </div>
  );
};
